// src/utils/communityApi.js
//
// The owner's facility in the YummiTracker lists (backend
// routes/facilityCommunity.ts): the lists it is in, the photos taken there,
// the comments, and the « Réponse de l'établissement » under a photo.
// Errors carry the backend's code in err.message (REPLY_TOO_LONG, ...).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
const BASE = `${API_BASE_URL}/v2/community`;

async function call(method, path, token, body) {
  const r = await fetch(`${BASE}${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(data.error || `HTTP_${r.status}`);
    err.status = r.status;
    throw err;
  }
  return data;
}

export const community = (facilityId, token) => call('GET', `/${Number(facilityId)}`, token);
export const replyToPhoto = (facilityId, photoId, body, token) =>
  call('PUT', `/${Number(facilityId)}/photos/${Number(photoId)}/reply`, token, { body });
export const deleteReply = (facilityId, photoId, token) =>
  call('DELETE', `/${Number(facilityId)}/photos/${Number(photoId)}/reply`, token);
